<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['买家展期约见']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="6">
            <span class="search-text">买家公司名称：</span>
            <el-input
              clearable
              v-model="form.fromCompanyName"
              placeholder="请输入预约买家公司名称"
              class="search-item"
              size="small"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-button
              @click="search"
              class="btn-search"
              round
              icon="el-icon-search"
              size="small"
              >查询</el-button
            >
            <el-button
              @click="reset"
              type="warning"
              round
              icon="el-icon-refresh"
              size="small"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <el-table
            :data="tableData"
            style="width: 100%"
            border
            class="flex-1" stripe height="100%"
          >
            <el-table-column
              type="index"
              width="60px"
              fixed
              align="center"
            ></el-table-column>
            <el-table-column label="预约买家姓名" prop="fromUserName" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="预约买家手机号" prop="fromUserPhone" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="预约买家公司名称" prop="fromCompanyName" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="预约买家类型" prop="fromEnterpriseType" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="预约时间" prop="meetDate" align="center">
            </el-table-column>
            <el-table-column align="center" label="操作" width="220">
              <template v-slot="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click="modifyStatus(scope.row, '3')"
                  icon="el-icon-check"
                  >接受</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click="modifyStatus(scope.row, '2')"
                  icon="el-icon-close"
                  >拒绝</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click="checkDetail(scope.row.id)"
                  icon="el-icon-document"
                  >查看联系方式</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>

    <el-dialog
      title="拒绝"
      width="30%"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :show-close="false"
      @close="cancel"
    >
      <el-form :model="verifyForm" ref="verifyForm" :rules="rules" label-width="100px" v-if="dialogShow">
        <el-form-item label="原因：" prop="reasons">
          <el-input type="textarea" v-model="verifyForm.reasons" placeholder="请输入" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  data () {
    return {
      form: {
        fromUserName: '',
        fromUserPhone: '',
        fromCompanyName: '',
        toUserName: '',
        toUserPhone: '',
        toCompanyName: '',
        startTime: '',
        endTime: ''
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableHeight: 0,
      time: [],
      dialogShow: false,
      verifyForm: {
        id: '',
        status: '',
        reasons: ''
      },
      rules: {
        reasons: {
          required: true,
          message: '请输入原因',
          trigger: 'blur'
        }
      },
      statusList: [
        {
          label: '待查看',
          value: '1'
        },
        {
          label: '拒绝',
          value: '2'
        },
        {
          label: '接受',
          value: '3'
        },
        {
          label: '取消',
          value: '4'
        }
      ]
    }
  },
  components: {
    navHeader
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 440
    this.getPageList()
  },
  methods: {
    async getPageList () {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.form
      }
      const { data: res } = await this.$http.post(
        '/offlineMeet/getPageList',
        params
      )
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    getTime (val) {
      this.form.startTime = val ? val[0] : ''
      this.form.endTime = val ? val[1] : ''
    },
    reset () {
      this.form = {
        fromUserName: '',
        fromUserPhone: '',
        fromCompanyName: '',
        toUserName: '',
        toUserPhone: '',
        toCompanyName: '',
        startTime: '',
        endTime: ''
      }
      this.currentPage = 1
      this.pageSize = 10
      this.getPageList()
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    checkDetail (id) {
      this.$router.push({
        name: 'OfflineReservationDetail',
        query: { id }
      })
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    modifyStatus (row, type) {
      this.verifyForm.id = row.id
      this.verifyForm.status = type
      this.verifyForm.reasons = ''
      if (type === '3') {
        this.$confirm('确定接受?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http
            .post('/offlineMeet/modifyStatus', this.verifyForm)
            .then(res => {
              if (res.data.code === '200') {
                this.getPageList()
                this.$message.success(res.data.msg)
              }
            })
        })
      } else {
        this.verifyForm.id = row.id
        this.verifyForm.status = type
        this.dialogShow = true
      }
    },
    cancel () {
      this.dialogShow = false
      this.verifyForm = {
        id: '',
        status: '',
        reasons: ''
      }
    },
    confirm () {
      this.$refs.verifyForm.validate(val => {
        if (val) {
          if (!['2', '4'].includes(this.verifyForm.status)) { this.verifyForm.reasons = '' }
          this.$http
            .post('/offlineMeet/modifyStatus', this.verifyForm)
            .then(res => {
              if (res.data.code === '200') {
                this.dialogShow = false
                this.getPageList()
                this.$message.success(res.data.msg)
              }
            })
        }
      })
    },
    getTimeRange (row) {
      const startTime = row.startTime ? row.startTime.slice(0, 10) : ''
      const endTime = row.endTime ? row.endTime.slice(0, 10) : ''
      return `${startTime}~${endTime}`
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/offlineReservation/index.vue